import './CustomIndicatorsExplorer.css';

import React, { useState } from 'react';
import Banner from '../../b2b-common/Banner';
import { deleteQualitativeIndicator, deleteQuantitativeDimensionalIndicator, deleteQuantitativeIndicator, fetchCustomIndicatorsData } from '../../../services/b2b-indicators-apiService';
import IndicatorCard from '../components/IndicatorCard';
import IndicatorsSearchForm from '../components/IndicatorsSearchForm';
import B2BElementsExplorer from '../../b2b-common/B2BElementsExplorer';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import CustomButton from '../../b2b-common/CustomButton';
import { Add } from '@mui/icons-material';
import EditCustomIndicatorModal from '../modal/EditCustomIndicatorModal';
import { showNotification } from '../../b2b-common/Notification';
import { useLoginContext } from '../../../App';
import { useContentContext } from '../../layout/Layout';

const CustomIndicatorsExplorer = () => {
    const { t } = useB2BTranslation('b2b-indicators');
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();

    const [customIndicatorsData, setCustomIndicatorsData] = useState([]);
    const [isSearching, setIsSearching] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagesCount, setPagesCount] = useState(1);
    const [refresh, setRefresh] = useState(true);

    const [pageNumberLoading, setPageNumberLoading] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedIndicator, setSelectedIndicator] = useState(null);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        setRefresh(true);
    };

    const handleIndicatorUpdate = (indicator) => {
        // console.log('handleIndicatorUpdate: ', indicator);
        setRefresh(true);
    }

    const handleDeleteCustomIndicator = async (indicator) => {
        console.log('handleDeleteCustomIndicator: ', indicator);
        const deleteIndicatorFunctions = {
            'QUANTITATIVE': deleteQuantitativeIndicator,
            'QUALITATIVE': deleteQualitativeIndicator,
            'QUANTITATIVE_DIMENSIONAL': deleteQuantitativeDimensionalIndicator,
        };
        try {
            const deleteFunction = deleteIndicatorFunctions[indicator.indicatorType];
            if (deleteFunction) {
                await deleteFunction(indicator.indicatorUUID, loginData.accessToken)
                    .then(() => {
                        setRefresh(true);
                        showNotification(setNotification, t('Indicator deleted'), 'success', 3000);
                    });
            } else {
                throw new Error(t('Unsupported indicator type'));
            }
        } catch (error) {
            console.error('Error deleting indicator', error);
            showNotification(setNotification, t('Error deleting indicator: ') + error, 'error', 5000);
        }
    }

    const handleShowCustomIndicatorModal = (indicator) => {
        // console.log('handleShowCustomIndicatorModal: ', indicator);
        setSelectedIndicator(indicator);
        setIsModalOpen(true);
    }

    const handleShowNewCustomIndicatorModal = () => {
        // console.log('handleShowNewCustomIndicatorModal');
        setSelectedIndicator(null);
        setIsModalOpen(true);
    }

    return (
        <div className='custom-explorer-page-container'>
            <Banner message={t('Custom indicators')} headingLevel='h1' underline={false} />
            <CustomButton label={t('New Indicator')} icon={<Add />} onClick={handleShowNewCustomIndicatorModal} className={'button-new-indicator'} />
            <IndicatorsSearchForm
                title={t('Search fields: ')}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                refresh={refresh}
                setRefresh={setRefresh}
                isSearching={isSearching}
                setIsSearching={setIsSearching}
                searchFunction={fetchCustomIndicatorsData}
                setIndicatorsData={setCustomIndicatorsData}
                setPagesCount={setPagesCount}
            />
            <B2BElementsExplorer
                isSearching={isSearching}
                elementsData={customIndicatorsData}
                pagesCount={pagesCount}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
                pageNumberLoading={pageNumberLoading}
                className="custom-indicators-explorer"
                ElementComponent={IndicatorCard}
                elementComponentPropName="indicator"
                otherComponentProps={{
                    className: 'custom-indicator-card b2b-indicator-theme-light-01',
                    showMoreButton: true,
                }}
                elementComponentHandlers={{
                    onDelete: handleDeleteCustomIndicator,
                    onEdit: handleShowCustomIndicatorModal,
                }}
            />
            {isModalOpen && (
                <EditCustomIndicatorModal
                    open={isModalOpen}
                    indicator={selectedIndicator}
                    onClose={() => setIsModalOpen(false)}
                    onUpdate={handleIndicatorUpdate}
                />
            )}
        </div>
    );
}

export default CustomIndicatorsExplorer;